export const NO_TOKEN_URL= [
    "login",
    "register"
]

export const LOGIN_URL = "https://retail.blaccdot.ae/login"
// export const LOGIN_URL = "business.blaccdot.co.uk/login"
//export const LOGIN_URL = "http://115.97.58.168:3000/login"

// export const LOGIN_URL = "https://business.blaccdot.com/login";


// export const LOGIN_URL = "https://apilead.blaccdot.com/ldsstage/auth/login"
